/**
 * Author(s) : Jerry Oswin
 * Purpose : This is a custom hook for getting viewport width for responsiveness.
 */
import React from "react";
import { useEffect } from "react"; 

const useViewport = () => {
    const [viewportWidth, setViewportWidth] = React.useState(window.innerWidth);
  
    useEffect(() => {
      const handleWindowResize = () => setViewportWidth(window.innerWidth);
      window.addEventListener("resize", handleWindowResize);
      return () => window.removeEventListener("resize", handleWindowResize);
    }, []);

    return { viewportWidth };
}

export default useViewport;